import { useClientMount } from "@/providers/ClientMountProvider";
import { useViewSize } from "@/providers/ViewSizeContext";
import { useEffect, useState } from "react";

export const useCalculatedScrollTrigger = (
  ref: React.RefObject<HTMLElement>,
  defaultTrigger: number,
  watchTargets: any[] = []
) => {
  const [triggerAmount, setTriggerAmount] = useState(defaultTrigger);
  const { mounted } = useClientMount();
  const { isReady } = useViewSize();
  useEffect(() => {
    if (!ref.current || !isReady || !mounted) return;
    const updateTriggerAmount = () => {
      const elementHeight = ref.current!.offsetHeight;
      const viewportHeight = window.innerHeight;
      console.log(elementHeight, viewportHeight);
      if (elementHeight > viewportHeight) {
        const maxPossibleTrigger = (viewportHeight * 0.65) / elementHeight;
        setTriggerAmount(Math.min(defaultTrigger, maxPossibleTrigger));
      } else {
        setTriggerAmount(defaultTrigger);
      }
    };
    updateTriggerAmount();
    window.addEventListener("resize", updateTriggerAmount);
    return () => window.removeEventListener("resize", updateTriggerAmount);
  }, [defaultTrigger, ref, isReady, mounted, ...watchTargets]);

  return { triggerAmount }
};
